export default __webpack_public_path__ + "static/media/dtsu5168_direct_master_4p.7f5faa37.jpg";